export default "__VITE_ASSET__Rbnjd8tq__"